<form [formGroup]="formGroup" class="d-flex flex-lg-row flex-column gap-2 px-3">
  <div class="input-group">
    <div class="col-12">
      <ncp-input [(options)]="inputOptions" />
    </div>
<!--    <div class="col-12 col-lg-6">-->
<!--      <ncp-input [(options)]="inputOptions" />-->
<!--    </div>-->
  </div>
</form>
